/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Try_Monthly_Plan_BodyInputs */

const en_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start small at ${i?.price}/month. Stay as long as it suits you, switch or cancel whenever you like.`)
};

const ar_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ابدأ بمبلغ بسيط قدره ${i?.price} شهرياً. استمر طالما يناسبك، وغيّر أو ألغِ في أي وقت تشاء.`)
};

const de_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starte klein mit ${i?.price}/Monat. Bleib, solange es dir passt, wechsle oder kündige jederzeit.`)
};

const es_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empieza con poco, ${i?.price}/mes. Quédate el tiempo que te convenga, cambia o cancela cuando quieras.`)
};

const fr_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commencez petit à ${i?.price}/mois. Restez aussi longtemps que ça vous convient, changez ou annulez quand vous voulez.`)
};

const it_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia con poco, ${i?.price}/mese. Resta finché ti va bene, cambia o annulla quando vuoi.`)
};

const ja_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`まずは月額${i?.price}から気軽にスタート。合う間だけ続けて、プラン変更もキャンセルもいつでも自由に。`)
};

const ko_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`월 ${i?.price}로 부담 없이 시작하세요. 마음에 드는 동안만 이용하고, 언제든 플랜 변경이나 취소가 가능합니다.`)
};

const pt_br_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comece pequeno por ${i?.price}/mês. Continue enquanto fizer sentido para você, mude ou cancele quando quiser.`)
};

const ru_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начните с малого — всего ${i?.price} в месяц. Оставайтесь, сколько вам удобно, меняйте план или отменяйте подписку в любой момент.`)
};

const th_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มต้นง่ายๆ ที่ ${i?.price}/เดือน อยู่ต่อได้นานเท่าที่คุณต้องการ เปลี่ยนแผนหรือยกเลิกได้ทุกเมื่อ`)
};

const tr_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/ay gibi küçük bir tutarla başlayın. Size uygun olduğu sürece kalın, istediğiniz zaman planı değiştirin veya iptal edin.`)
};

const zh_cn_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`先从每月 ${i?.price} 试试看，用得开心再继续，随时可以调整方案`)
};

const zh_tw_try_monthly_plan_body = /** @type {(inputs: Try_Monthly_Plan_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`先從每月 ${i?.price} 試試看，用得開心再繼續，可隨時調整方案`)
};

/**
* | output |
* | --- |
* | "Start small at {price}/month. Stay as long as it suits you, switch or cancel whenever you like." |
*
* @param {Try_Monthly_Plan_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const try_monthly_plan_body = /** @type {((inputs: Try_Monthly_Plan_BodyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Monthly_Plan_BodyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_try_monthly_plan_body(inputs)
	if (locale === "ar") return ar_try_monthly_plan_body(inputs)
	if (locale === "de") return de_try_monthly_plan_body(inputs)
	if (locale === "es") return es_try_monthly_plan_body(inputs)
	if (locale === "fr") return fr_try_monthly_plan_body(inputs)
	if (locale === "it") return it_try_monthly_plan_body(inputs)
	if (locale === "ja") return ja_try_monthly_plan_body(inputs)
	if (locale === "ko") return ko_try_monthly_plan_body(inputs)
	if (locale === "pt_br") return pt_br_try_monthly_plan_body(inputs)
	if (locale === "ru") return ru_try_monthly_plan_body(inputs)
	if (locale === "th") return th_try_monthly_plan_body(inputs)
	if (locale === "tr") return tr_try_monthly_plan_body(inputs)
	if (locale === "zh_cn") return zh_cn_try_monthly_plan_body(inputs)
	return zh_tw_try_monthly_plan_body(inputs)
});